export const ACTIVITY_STATUS = {
  SCHEDULED: "SCHEDULED",
  IN_WAITING_ROOM: "IN_WAITING_ROOM",
  STARTED: "STARTED",
  IN_HANGOUT_ROOM: "IN_HANGOUT_ROOM",
}

export const USER_STATUS_IN_ACTIVITY = {
  BOOKED: "BOOKED",
  LEFT: "LEFT",
}
